export default (color: any) => `<?xml version="1.0" encoding="UTF-8"?>
<svg width="12px" height="17px" viewBox="0 0 12 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->

    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="path-1" x="3" y="14.0434783" width="6" height="2.95652174"></rect>
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon/Notification/Positive/Idle-Default" transform="translate(-10.000000, -8.000000)">
            <g id="Bell" transform="translate(10.000000, 8.000000)">
                <path d="M6,0 L6,0 C9.3137085,-6.08718376e-16 12,2.6862915 12,6 L12,13.3043478 L0,13.3043478 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z" id="Rectangle-9" fill="${color}"></path>
                <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                </mask>
                <g id="Mask"></g>
                <ellipse id="Oval" fill="${color}" mask="url(#mask-2)" cx="6" cy="14.7826087" rx="2.25" ry="2.2173913"></ellipse>
            </g>
        </g>
    </g>
</svg>`;
